import { Button, Stack, Typography } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { Link, Mood, StarBorder } from '@mui/icons-material'
import { stopPropagationEvents } from '../LinkEditDrawer/LinkEditDrawer.utils'
import { useAddAllLinksCallbacks } from './AddAllLinks.hooks'
import useTranslation from 'next-translate/useTranslation'

export const AddAllLinks: FC = () => {
  const { handleAdvancedLinkOpen, handleSocialLinkOpen, handleStandardLinkOpen } =
    useAddAllLinksCallbacks()
  const { t } = useTranslation('page')
  return (
    <Stack
      sx={{
        padding: 4,
        mt: 4,
        width: '100%',
        alignItems: 'center'
      }}
      gap={4}
    >
      <Typography variant="subtitleSmall">{t('Nav.AddLink.title')}</Typography>

      <Button
        id="add-link"
        onClick={handleStandardLinkOpen}
        fullWidth
        variant="outlined"
        size="large"
        startIcon={Link}
        {...stopPropagationEvents}
      >
        {t('Nav.AddLink.buttons.standard')}
      </Button>

      <Button
        id="add-social-link"
        onClick={handleSocialLinkOpen}
        fullWidth
        variant="outlined"
        size="large"
        startIcon={Mood}
        {...stopPropagationEvents}
      >
        {t('Nav.AddLink.buttons.social')}
      </Button>

      <Button
        id="add-advanced-link"
        onClick={handleAdvancedLinkOpen}
        fullWidth
        variant="outlined"
        size="large"
        startIcon={StarBorder}
        {...stopPropagationEvents}
      >
        {t('Nav.AddLink.buttons.advanced')}
      </Button>
    </Stack>
  )
}
